<template>
  <svg
    class="hadrian-icons woman"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 21.478 40.738"
    style="enable-background: new 0 0 21.478 40.738"
    xml:space="preserve"
  >
    <g>
      <path
        d="M13.826,3.353c0,1.852-1.501,3.353-3.353,3.353c-1.851,0-3.353-1.502-3.353-3.353C7.121,1.501,8.622,0,10.473,0
		C12.325,0,13.826,1.501,13.826,3.353L13.826,3.353z M13.826,3.353"
      />
      <path
        d="M17.017,11.067c-0.75-2.184-2.009-3.292-3.74-3.292H7.671c-1.732,0-2.99,1.108-3.741,3.292
		c-1.163,3.385-3.805,10.613-3.831,10.685c-0.307,0.839,0.125,1.768,0.964,2.075c0.837,0.307,1.767-0.123,2.075-0.964
		c0.023-0.062,1.919-5.251,3.215-8.92c-0.087,0.71,0.189-0.796-2.298,12.048c-0.051,0.264,0.018,0.536,0.189,0.743
		c0.171,0.207,0.425,0.328,0.694,0.328h1.234v11.736c0,1.072,0.87,1.941,1.942,1.941c1.072,0,1.941-0.869,1.941-1.941V27.061h0.838
		v11.736c0,1.072,0.87,1.941,1.942,1.941c1.072,0,1.941-0.869,1.941-1.941V27.061h1.234c0.269,0,0.523-0.12,0.694-0.327
		c0.171-0.208,0.239-0.48,0.189-0.744c-2.508-12.949-2.212-11.341-2.305-12.102c1.395,3.821,3.655,9.587,3.766,9.872
		c0.326,0.832,1.264,1.242,2.097,0.915c0.832-0.326,1.242-1.265,0.916-2.097C21.334,22.497,18.174,14.434,17.017,11.067
		L17.017,11.067z M17.017,11.067"
      />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>
